// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
// hooks
import useAuth from '../../../../hooks/useAuth';
// assets
import UserImage from '../../../../assets/user.png';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user } = useAuth();

  const getProfileImage = () => {
    if(user && user.profile_image_url){
      return user.profile_image_url;
    }else{
      return UserImage;
    }
  }

  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <Avatar
          src={ getProfileImage() }
          alt="Me"
        />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap sx={{ maxWidth: 150 }}>
            { user?.first_name } { user?.last_name }
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary', maxWidth: 150 }}>
            { user?.email }
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
